import { render, staticRenderFns } from "./rewardBridgeGameEdit.vue?vue&type=template&id=6f787da6&scoped=true&"
import script from "./rewardBridgeGameEdit.vue?vue&type=script&lang=js&"
export * from "./rewardBridgeGameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f787da6",
  null
  
)

export default component.exports